document.addEventListener('DOMContentLoaded', function () {
  function initLeadTimeCalendar() {
    const leadEls = document.querySelectorAll('.cart-lead-time');
    
    if (!leadEls.length) {
      setTimeout(initLeadTimeCalendar, 150);
      return;
    }

    const leadTimes = [...leadEls].map(el => parseInt(el.dataset.leadTime || 0));
    const maxLeadTime = Math.max(...leadTimes, 0);
    
    if (maxLeadTime <= 0) return; // No lead time restriction

    const today = new Date();
    const cutoffDate = new Date(today);
    cutoffDate.setDate(today.getDate() + maxLeadTime);
    cutoffDate.setHours(23, 59, 59, 999); // End of the day

    function disableBlockedDates() {
      const dateButtons = document.querySelectorAll('.rdp-day:not(.rdp-day_disabled)');
      
      dateButtons.forEach(button => {
        if (button.classList.contains('rdp-day_disabled')) return;
        
        const buttonDate = parseCalendarDate(button);
        if (!buttonDate) return;
        
        if (buttonDate < cutoffDate) {
          button.classList.add('rdp-day_disabled');
          button.setAttribute('disabled', '');
          button.setAttribute('tabindex', '-1');
        }
      });
    }

    function parseCalendarDate(button) {
      // Get the full date from the button's data attribute or time element
      const timeEl = button.querySelector('time');
      if (timeEl && timeEl.dateTime) {
        return new Date(timeEl.dateTime);
      }
      
      // Fallback: parse from text content and calendar header
      const dayText = button.textContent.trim();
      if (!dayText || isNaN(parseInt(dayText))) return null;
      
      const day = parseInt(dayText);
      const monthYearEl = document.querySelector('.rdp-caption_label');
      if (!monthYearEl) return null;
      
      const monthYearText = monthYearEl.textContent.trim();
      const [monthName, year] = monthYearText.split(' ');
      
      // Create date using month name
      const date = new Date(`${monthName} ${day}, ${year}`);
      if (isNaN(date.getTime())) return null;
      
      return date;
    }

    // Run after calendar loads
    setTimeout(disableBlockedDates, 150);
    
    // Also run when calendar navigation changes
    const calendarContainer = document.querySelector('.rdp') || document.body;
    if (calendarContainer) {
      const observer = new MutationObserver(function(mutations) {
        // Only run if calendar structure changed
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length || mutation.removedNodes.length) {
            setTimeout(disableBlockedDates, 50);
          }
        });
      });
      
      observer.observe(calendarContainer, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false
      });
    }
    
    // Re-run on month navigation (if calendar uses buttons)
    document.addEventListener('click', function(event) {
      if (event.target.closest('.rdp-nav_button')) {
        setTimeout(disableBlockedDates, 100);
      }
    });
  }

  // Initial startup
  initLeadTimeCalendar();
});




/*quantity-dimension-calculator-nov-13*/

document.addEventListener('DOMContentLoaded', function() {
  // --- INITIAL SETUP ---
  const coverageEl = document.querySelector('.coverage-per-box');
  let coveragePerBox = parseFloat(coverageEl?.dataset.coverageValue || 0);
  const ftToMeter = 0.3048;

  const calcQtyEl = document.getElementById('calculated-quantity');
  const calcQtyContainer = calcQtyEl?.parentElement;
  const manualQtyEl = document.getElementById('manual-quantity');

  const modeInputs = document.querySelectorAll('input[name="calc-mode"]');
  const qtyInput = document.getElementById('quantity-input');
  const dimInput = document.getElementById('dimension-input');
  const widthEl = document.getElementById('width');
  const lengthEl = document.getElementById('length');
  const unitEls = document.querySelectorAll('input[name="unit"]');

  // Wastage checkbox
  const wastageCheckbox = document.getElementById('add-wastage');
  const wastageContainer = document.getElementById('wastage-checkbox');

  // External quantity input where we mirror calculated qty
  const quantityOutputInput = document.querySelector('[data-quantity-input]');

  // Create or find total coverage display
  let coverageDisplay = document.getElementById('total-coverage-display');
  if (!coverageDisplay && qtyInput) {
    coverageDisplay = document.createElement('div');
    coverageDisplay.id = 'total-coverage-display';
    coverageDisplay.style.marginTop = '0.5rem';
    qtyInput.appendChild(coverageDisplay);
  }

  // --- MODE TOGGLING ---
  function toggleMode(mode) {
    if (mode === 'dimension') {
      qtyInput.style.display = 'none';
      dimInput.style.display = 'block';
      coverageDisplay.style.display = 'none';
      calcQtyContainer.style.display = 'block';
      wastageContainer.style.display = 'block';
      calculateQuantityFromDimensions();
    } else {
      qtyInput.style.display = 'block';
      dimInput.style.display = 'none';
      coverageDisplay.style.display = 'block';
      calcQtyContainer.style.display = 'none';
      wastageContainer.style.display = 'none';
      calculateCoverageFromQuantity();
    }
  }

  modeInputs.forEach(input => {
    input.addEventListener('change', () => toggleMode(input.value));
  });

  // --- CALCULATIONS ---

  // Quantity → Total Coverage
  function calculateCoverageFromQuantity() {
    const quantity = parseFloat(manualQtyEl.value) || 0;
    const totalCoverage = quantity * coveragePerBox;

    coverageDisplay.textContent =
      totalCoverage > 0
        ? `Provides Total coverage: ${totalCoverage.toFixed(2)} m²`
        : '';
  }

  manualQtyEl.addEventListener('input', () => {
    if (document.querySelector('input[name="calc-mode"]:checked')?.value === 'quantity') {
      calculateCoverageFromQuantity();
    }
  });

  // Dimensions → Required Quantity (+ optional 10% wastage)
  function calculateQuantityFromDimensions() {
    const width = parseFloat(widthEl?.value) || 0;
    const length = parseFloat(lengthEl?.value) || 0;
    const unit = document.querySelector('input[name="unit"]:checked')?.value;

    let widthM = width;
    let lengthM = length;

    if (unit === 'ft') {
      widthM = width * ftToMeter;
      lengthM = length * ftToMeter;
    }

    if (widthM > 0 && lengthM > 0 && coveragePerBox > 0) {
      let area = widthM * lengthM;

      // Apply 10% wastage if checked
      if (wastageCheckbox?.checked) {
        area = area * 1.10;
      }

      const quantity = Math.ceil(area / coveragePerBox);

      // Show inside calculated quantity span
      calcQtyEl.textContent = quantity;

      // 🔥 ALSO MIRROR INTO THE EXTERNAL QUANTITY INPUT
      if (quantityOutputInput) {
        quantityOutputInput.value = quantity;
      }

    } else {
      calcQtyEl.textContent = '—';

      // Clear external input when invalid
      if (quantityOutputInput) {
        quantityOutputInput.value = '';
      }
    }
  }

  widthEl?.addEventListener('input', calculateQuantityFromDimensions);
  lengthEl?.addEventListener('input', calculateQuantityFromDimensions);
  unitEls?.forEach(u => u.addEventListener('change', calculateQuantityFromDimensions));
  wastageCheckbox?.addEventListener('change', calculateQuantityFromDimensions);

  // --- VARIANT BUTTON CLICK HANDLER ---
  const variantButtons = document.querySelectorAll('[data-variant-coverage-value]');
  variantButtons.forEach(button => {
    button.addEventListener('click', function() {
      const newCoverage = parseFloat(this.dataset.variantCoverageValue || 0);

      if (newCoverage && newCoverage > 0) {
        coveragePerBox = newCoverage;

        // Recalculate based on current mode
        const currentMode = document.querySelector('input[name="calc-mode"]:checked')?.value;

        if (currentMode === 'dimension') {
          calculateQuantityFromDimensions();
        } else {
          calculateCoverageFromQuantity();
        }
      }
    });
  });

  // --- INITIAL LOAD ---
  toggleMode('quantity');
});










/*product-block-header 12-nov*/

document.addEventListener('DOMContentLoaded', () => {
  const variantButtons = document.querySelectorAll('[data-button]');
  const priceEl = document.querySelector('[data-product-price]');
  if (!variantButtons.length || !priceEl) return;

  // Find the variant with the lowest price per unit
  let minVariant = null;
  let minPricePerUnit = Infinity;

  variantButtons.forEach(button => {
    const variantPrice = parseFloat(button.dataset.variantActualPrice);
    const coverage = parseFloat(button.dataset.variantCoverageValue);

    // Skip if invalid data
    if (isNaN(variantPrice) || variantPrice <= 0) return;

    // Calculate per-unit price if coverage exists
    const pricePerUnit = !isNaN(coverage) && coverage > 0
      ? variantPrice / coverage
      : variantPrice;

    // Compare to find lowest
    if (pricePerUnit < minPricePerUnit) {
      minPricePerUnit = pricePerUnit;
      minVariant = button;
    }
  });

  // Activate the cheapest variant
  if (minVariant) {
    // Simulate a click (so all your existing logic runs)
    minVariant.click();

    // Add active class for styling if not handled automatically
    variantButtons.forEach(btn => btn.classList.remove('active'));
    minVariant.classList.add('active');
  }
});



/*product-information-section*/

document.addEventListener('DOMContentLoaded', () => {
  // Handle tab buttons globally or per section
  document.querySelectorAll('.tab-button').forEach(button => {
    button.addEventListener('click', () => {
      const parent = button.closest('.tab-container') || document;

      // Remove 'active' from all buttons and content within the same container
      parent.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));
      parent.querySelectorAll('.tab-content').forEach(tab => tab.classList.remove('active'));

      // Activate selected button and related tab
      button.classList.add('active');
      const targetId = button.dataset.tab;
      const target = parent.querySelector(`#${targetId}`);
      if (target) target.classList.add('active');
    });
  });
});
